import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from './router'
import './style.css'
import { initTheme } from './composables/useTheme'
import { initErrorReporting } from './lib/errorReporting'
import { registerServiceWorker } from './lib/registerServiceWorker'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
initErrorReporting(app, router)
initTheme()

app.use(pinia)
app.use(router)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
app.use(VueQueryPlugin, { queryClient })

app.mount('#app')
registerServiceWorker()

